import Svg, { Line, Path } from 'react-native-svg';
import { ICurvedArrow } from './Tutorial.types';

export const CurvedArrow = ({
  startX,
  startY,
  endX,
  endY,
  strokeColor = '#000000',
  strokeWidth = 2,
  arrowSize = 10,
  curvature = 0.2,
}: ICurvedArrow) => {
  const midX = (startX + endX) / 2;
  const midY = (startY + endY) / 2;

  const dx = endX - startX;
  const dy = endY - startY;
  const distance = Math.sqrt(dx * dx + dy * dy);

  const offsetDistance = distance * curvature;
  const controlX = midX - (dy / distance) * offsetDistance;
  const controlY = midY + (dx / distance) * offsetDistance;

  const tangentX = endX - controlX;
  const tangentY = endY - controlY;
  const tangentAngle = Math.atan2(tangentY, tangentX);

  const arrowPoint1X = endX - arrowSize * Math.cos(tangentAngle - Math.PI / 6);
  const arrowPoint1Y = endY - arrowSize * Math.sin(tangentAngle - Math.PI / 6);
  const arrowPoint2X = endX - arrowSize * Math.cos(tangentAngle + Math.PI / 6);
  const arrowPoint2Y = endY - arrowSize * Math.sin(tangentAngle + Math.PI / 6);

  const pathData = `M ${startX} ${startY} Q ${controlX} ${controlY} ${endX} ${endY}`;

  return (
    <Svg
      style={{
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        overflow: 'visible',
      }}
    >
      <Path d={pathData} stroke={strokeColor} strokeWidth={strokeWidth} fill="none" />
      <Line
        x1={arrowPoint1X}
        y1={arrowPoint1Y}
        x2={endX}
        y2={endY}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <Line
        x1={endX}
        y1={endY}
        x2={arrowPoint2X}
        y2={arrowPoint2Y}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </Svg>
  );
};
